import { render } from "./expenses-report-table.vue?vue&type=template&id=8a2a21c4"
import script from "./expenses-report-table.vue?vue&type=script&lang=js"
export * from "./expenses-report-table.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__